import root from 'window-or-global';
import {AccountLinkingBridge} from '../accountLinkingBridge';

const accountLinkingWeb: AccountLinkingBridge = {
    linkAccount: async (): Promise<void> => {
        root.location.href = root.clientEnvConfig && root.clientEnvConfig.EPIC_UBI_LINK_URL;
    },
    registerResponseCallback: async (): Promise<void> => undefined
};

export default accountLinkingWeb;
